angular
  .module('eventcodeUsers')
  .component('eventcodeUsers', {
    template: require('./eventcode-users.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function EventcodeUsersViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'eventcode';
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $scope.tbEventCodeId = $routeParams.tb_event_code_id;

        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.codes = {};
        this.total_count = 0;
        this.paging = (page) => {
          $resource(`${APIURL}/admin/eventcode/${$scope.tbEventCodeId}/users`).get({ page: page - 1 },
            (data) => {
              console.log(data);
              this.users = data.users;
              this.total_count = data.total_count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/eventcode-users/eventcode-users.component.js